import { Paper } from '@mui/material';
import { styled } from '@mui/system';
import VerifiedIcon from '@mui/icons-material/Verified';

export const CertificateCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  textAlign: 'center',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.mode === 'dark'
    ? (theme.custom?.glass?.bgDark || 'rgba(255, 255, 255, 0.06)')
    : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
  borderRadius: '16px',
  border: theme.palette.mode === 'dark'
    ? (theme.custom?.glass?.borderDark || '1px solid rgba(255,255,255,0.10)')
    : '1px solid rgba(0,0,0,0.06)',
  backdropFilter: theme.palette.mode === 'dark' ? (theme.custom?.glass?.blur || 'blur(14px)') : undefined,
  boxShadow: theme.palette.mode === 'dark'
    ? (theme.custom?.shadows?.softDark || '0 16px 40px rgba(0, 0, 0, 0.55)')
    : '0 16px 40px rgba(0, 0, 0, 0.12)',
  transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background: theme.palette.mode === 'dark'
      ? (theme.custom?.gradients?.brand || 'linear-gradient(90deg, #BB86FC 0%, #03DAC6 100%)')
      : 'linear-gradient(90deg, rgba(30,60,114,0.18) 0%, rgba(42,82,152,0.18) 100%)',
    opacity: theme.palette.mode === 'dark' ? 0.10 : 0.06,
    pointerEvents: 'none',
  },
  '& > *': {
    position: 'relative',
    zIndex: 1,
  },
  '&:hover': {
    transform: 'translateY(-6px)',
    boxShadow: theme.palette.mode === 'dark'
      ? (theme.custom?.shadows?.glowPrimary || '0 0 0 1px rgba(187, 134, 252, 0.16), 0 12px 40px rgba(187, 134, 252, 0.18)')
      : '0 18px 50px rgba(0, 0, 0, 0.16)',
    borderColor: theme.palette.mode === 'dark' ? 'rgba(3, 218, 198, 0.40)' : 'rgba(30, 60, 114, 0.25)',
  },
}));

export const CertificateIcon = styled(VerifiedIcon)(({ theme }) => ({
  fontSize: '48px',
  color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main,
  marginBottom: theme.spacing(2),
}));
